module.exports = __webpack_public_path__ + "site/img/73.457ba48c.jpg";